// Backend client-storage flag: the first-recording intro is shown at most once per user.
export const RECORDING_INTRO_STORAGE_KEY = 'recordingIntroShown';
